import React from "react";

export default function ICC(props) {
  return (
    <div>
      <h1 className="text-3xl font-bold mb-6 text-yellow-500">
        Internal Complaints Committee (ICC)
      </h1>

      <div className="space-y-5">
        <div className="rounded-xl p-6 bg-white border border-gray-200 shadow-sm">
          <span className="text-gray-700 block mb-4">
            An Internal Complaints Committee (ICC) shall be constituted by CEO,
            SS in terms of and governed by Sexual Harassment of Women at
            Workplace (Prevention, Prohibition and Redressal) Act, 2013.
          </span>
          <span className="text-gray-700 block mb-4">
            Accordingly, CEO, SS has constituted an ICC, the details of which
            are given hereunder. The tenure of the ICC is upto three years from
            the date this policy is effective i.e. upto September 30, 2027.
          </span>
          <span className="text-gray-700 block mb-4">
            The SS Internal Complaints Committee (ICC) is empowered to
            investigate complaints or allegations of sexual harassment and
            address them in a timely, confidential, impartial and sensitive
            manner.
          </span>

          {/* Table */}
          <table className="min-w-full border-collapse border border-gray-300 mb-4">
            <thead>
              <tr className="bg-gray-100">
                <th className="border border-gray-300 px-4 py-2 text-left">
                  Name
                </th>
                <th className="border border-gray-300 px-4 py-2 text-left">
                  Designation at SS
                </th>
                <th className="border border-gray-300 px-4 py-2 text-left">
                  Location
                </th>
                <th className="border border-gray-300 px-4 py-2 text-left">
                  Designation in ICC
                </th>
                <th className="border border-gray-300 px-4 py-2 text-left">
                  Email
                </th>
              </tr>
            </thead>
            <tbody>
              <tr className="hover:bg-gray-50">
                <td className="border border-gray-300 px-4 py-2">
                  Shiba Markas
                </td>
                <td className="border border-gray-300 px-4 py-2">
                  Program Manager
                </td>
                <td className="border border-gray-300 px-4 py-2">Nagpur</td>
                <td className="border border-gray-300 px-4 py-2">
                  Presiding Officer
                </td>
                <td className="border border-gray-300 px-4 py-2">
                  <a
                    href="mailto:Shiba.Markas@slumsoccer.org"
                    className="text-yellow-500 hover:underline"
                  >
                    Shiba.Markas@slumsoccer.org
                  </a>
                </td>
              </tr>
              <tr className="hover:bg-gray-50">
                <td className="border border-gray-300 px-4 py-2">Mahima B</td>
                <td className="border border-gray-300 px-4 py-2">
                  Program Manager
                </td>
                <td className="border border-gray-300 px-4 py-2">Nagpur</td>
                <td className="border border-gray-300 px-4 py-2">Member</td>
                <td className="border border-gray-300 px-4 py-2">
                  <a
                    href="mailto:Mahima.b@slumsoccer.org"
                    className="text-yellow-500 hover:underline"
                  >
                    Mahima.b@slumsoccer.org
                  </a>
                </td>
              </tr>
              <tr className="hover:bg-gray-50">
                <td className="border border-gray-300 px-4 py-2">
                  Shivani Chaudhari
                </td>
                <td className="border border-gray-300 px-4 py-2">
                  Program Manager
                </td>
                <td className="border border-gray-300 px-4 py-2">Nagpur</td>
                <td className="border border-gray-300 px-4 py-2">Member</td>
                <td className="border border-gray-300 px-4 py-2">
                  <a
                    href="mailto:Shivani.chaudhri@slumsoccer.org"
                    className="text-yellow-500 hover:underline"
                  >
                    Shivani.chaudhri@slumsoccer.org
                  </a>
                </td>
              </tr>
              <tr className="hover:bg-gray-50">
                <td className="border border-gray-300 px-4 py-2">
                  Sajid Jamal
                </td>
                <td className="border border-gray-300 px-4 py-2">
                  Program Manager
                </td>
                <td className="border border-gray-300 px-4 py-2">Nagpur</td>
                <td className="border border-gray-300 px-4 py-2">Member</td>
                <td className="border border-gray-300 px-4 py-2">
                  <a
                    href="mailto:Sajid.Jamal@slumsoccer.org"
                    className="text-yellow-500 hover:underline"
                  >
                    Sajid.Jamal@slumsoccer.org
                  </a>
                </td>
              </tr>
              <tr className="hover:bg-gray-50">
                <td className="border border-gray-300 px-4 py-2">
                  Kanak Wadhwani
                </td>
                <td className="border border-gray-300 px-4 py-2">
                  Asst. Prof. RDB Engg College
                </td>
                <td className="border border-gray-300 px-4 py-2">Nagpur</td>
                <td className="border border-gray-300 px-4 py-2">
                  External Member
                </td>
                <td className="border border-gray-300 px-4 py-2">
                  <a
                    href="mailto:Kanak.Swadhwani@gmail.com"
                    className="text-yellow-500 hover:underline"
                  >
                    Kanak.Swadhwani@gmail.com
                  </a>
                </td>
              </tr>
            </tbody>
          </table>

          <span className="text-gray-700 block mb-1">
            The ICC shall, in receiving, conducting inquiries into, disposing
            of, and otherwise handling, complaints, adhere to the procedure
            below and be guided by the relevant provisions of Sexual Harassment
            of Women at Workplace (Prevention, Prohibition and Redressal) Act,
            2013.
          </span>
        </div>
      </div>
    </div>
  );
}
